module.exports = __webpack_public_path__ + "media/images/plus-test-0fa9ae9b55f3c0289d7bc79092d43161.svg";